export enum UnityLipsyncCommads {
  PutAudioSampleData = 'WebPutAudioSampleData',
  SetLipsyncPosition = 'WebSetLipsyncPosition',
  SetupPhonemes = 'WebSetupPhonemes',
}
